<template>
  <WdsText v-if="isDirect" secondary :text="$t('Direct')" :data-test="dataTest" />
  <WdsStack v-else align-center gap-sm class="tw-min-w-0" :data-test="dataTest">
    <AvatarWithFallback
      :id="managingCompany.id"
      :avatar="managingCompany.avatar"
      sm
      class="tw-shrink-0"
      data-test="relation-logo"
    />
    <WdsText class="tw-truncate" :text="managingCompany.name" :title="managingCompany.name" />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import AvatarWithFallback from '@/components/AvatarWithFallback.vue'

defineProps<{
  isDirect: boolean
  managingCompany: { id: string; name: string; avatar?: string | null }
  dataTest?: string
}>()
</script>

